import {useTranslation} from '../context/TranslationContext';
import {Marketplace} from '../types';
import {formatDisplayDate} from '../util/DateUtil';

interface ConnectedSuppliersPanelProps {
    marketplace: Marketplace;
}

export const ConnectedSuppliersPanel = ({marketplace}: ConnectedSuppliersPanelProps) => {
    const {t} = useTranslation();
    const suppliers = marketplace.marketplaceSuppliers;

    return (
        <div className="apx-marketplace-suppliers-panel">
            <h4>
                {t('apx-marketplaces-connected-suppliers')} — {marketplace.displayName || marketplace.name}
            </h4>

            {suppliers.length === 0 ? (
                <div className="text-center text-muted py-5">
                    {t('apx-marketplaces-no-connected-suppliers')}
                </div>
            ) : (
                <table className="table table-autofit table-hover table-list">
                    <thead>
                        <tr>
                            <th>{t('supplier')}</th>
                            <th>{t('apx-marketplaces-full-export-date')}</th>
                            <th>{t('apx-marketplaces-update-export-date')}</th>
                            <th>{t('apx-marketplaces-export-version')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {suppliers.map((supplier) => (
                            <tr key={supplier.supplierName}>
                                <td>{supplier.displayName}</td>
                                <td>{formatDisplayDate(supplier.fullExportDate)}</td>
                                <td>{formatDisplayDate(supplier.updateExportDate)}</td>
                                <td>{supplier.exportVersion}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};
